// extracted by mini-css-extract-plugin
export default {"footer":"J_cG","footer_logo":"J_cH","navLinks":"J_cJ","column":"J_cK","columnHeading":"J_cL","copyright":"J_cM","socialMediaLinks":"J_cN"};